<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title"><i class="fas fa-fw fa-file-import me-2"></i> Importer des données</h5>
    <button (click)="activeModal.close()" aria-label="Close" class="btn-close" data-bs-dismiss="modal"
    type="button"></button>
  </div>
  <div class="modal-body">
    <h2>Importer un fichier (.optitax)</h2>
    <div class="text-center mt-5">
      <button (click)="importFile()" class="btn btn-primary btn-lg" type="button">
        <i class="fas fa-fw fa-file-import me-2"></i> Importer un fichier (.optitax)
      </button>
    </div>
    <hr class="mt-5 mb-3">
    <h3>Calculs démonstratifs</h3>

    <p class="text-secondary">Ces calculs démonstratifs vont vous permettre de tester et d'expérimenter Optitax sans
      avoir à
      rentrer toutes les données
    manuellement.</p>

    @if (loading) {
      <div class="alert alert-primary d-flex">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <div class="ms-2 align-self-center">
          Chargement en cours.
        </div>
      </div>
    }

    @if (calculationKeyname === 'ROLLOVER') {
      <div>
        <h4 class="mt-3">Roulement</h4>
        <div class="list-group">
          <button (click)="rolloverScenario1()" [class.disabled]="loading" class="list-group-item list-group-item-action"
            type="button">
            <i class="fas fa-file-excel"></i> Roulement - Scénario #1 - Roulement complexe avec hypothèque
          </button>
        </div>
      </div>
    }

    @if (calculationKeyname === 'SALARY_DIVIDEND_SIMULATION') {
      <div>
        <h4 class="mt-3">Salaire ou dividendes</h4>
        <div class="list-group">
          <button (click)="salaryVsDividendsScenario1()" [class.disabled]="loading"
            class="list-group-item list-group-item-action" type="button">
            <i class="fas fa-file-excel"></i> Salaire ou dividendes - Scénario #1 - Jean et Jeanne Tremblay - 3
            enfants - Train de vie de 60 000$ (Salaire combiné: 65 000$)
          </button>
        </div>
        <div class="list-group">
          <button (click)="salaryVsDividendsScenario2()" [class.disabled]="loading"
            class="list-group-item list-group-item-action" type="button">
            <i class="fas fa-file-excel"></i> Salaire ou dividendes - Scénario #2 - Steve Bélair - 3
            enfants - Train de vie de 80 000$
          </button>
        </div>
      </div>
    }

  </div>
  <div class="modal-footer">
    <button (click)="activeModal.close()" class="btn btn-secondary" type="button">Close</button>
  </div>
</div>
